import { IShowroomProductMedia } from "@faire/deprecated-retailer-visitor-shared/views/product/images/types";
import { lazy } from "react";

export interface IProps {
  index: number;
  productMedia: IShowroomProductMedia[];
  onChangeIndex: (value: number) => void;
  onClose: () => void;
  eventName: string;
}

export const LazyImageGallery = lazy(() =>
  import(
    /* webpackChunkName: "ImageGallery" */
    "@faire/deprecated-retailer-visitor-shared/components/ImageGallery/ImageGallery"
  ).then((m) => ({ default: m.ImageGallery }))
);
